import React, { Component } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class GetTransactionDetail extends Component {

    

    render() {

        // var userToken = localStorage.getItem('token');
        // if(! userToken) {
        //       return <Navigate  to='/login' replace="true" />
        //   }

        var request_data = JSON.stringify({
            "transaction_id": "TPEP000001938178"
        }, null, 2);

        var response_data = JSON.stringify({
            "success": true,
            "data": {
                "id": "TPEP000001938178",
                "created_at": "2026-05-28T09:37:25.000Z",
                "amount": "85.36",
                "status": "success",
                "sender": {
                    "first_name": "sachin",
                    "last_name": "rana",
                    "mobile_no": "8954133055",
                    "email": "sachin@gmail.com"
                },
                "receiver": {
                    "first_name": "Karam",
                    "last_name": "Jeet",
                    "nationality": "IND",
                    "currency": "INR",
                    "country": "IN",
                    "city": "CHD"
                }
            }
        }, null, 2);

        var error_response = JSON.stringify({
            "success": false,
            "message": "Transaction not found"
        }, null, 2);
      
        const copyClipboard = (e,data) => {
            console.log('copyClipboard');
            e.preventDefault();
            navigator.clipboard.writeText(data);
            toast.success('Data copied !', {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000
            });
        };

        return (
            <div>
                <div class="docs-content">
                    <div class="container">
                        <article class="docs-article" id="section-1">
                        <h1 class="docs-heading">Get Transaction Detail</h1>
                        <section class="docs-intro">
                            <p>
                                Calculates the exchange rate, sender amount, receiver amount, and
                                transaction fees for the selected payout corridor.
                            </p>

                            <p>
                                This API returns the latest transaction status and complete transaction information for a specific remittance transaction.

                                Use this API as the primary source of truth for transaction tracking, reconciliation, customer support enquiries, reporting, and status monitoring.

                                After a transaction is successfully created using the Make Payment API, store the returned transaction ID and use this API whenever transaction details or status updates are required.
                            </p>
                        </section>
                        </article>

                        <article class="docs-article" id="section-2">
                            <header class="docs-header">
                                <h1 class="docs-heading">
                                    Get Transaction Detail Reference
                                </h1>
                                <section class="docs-intro row">
                                    <div class="col-lg-6 col-12">
                                    <p>
                                        This POST API retrieves the latest status and complete information for an existing remittance transaction.
                                    </p>
                                    <div class="alert alert-info mt-3">
                                        <b>When to Use</b>
                                        <p class="mb-0">
                                            Call this API after a transaction has been created and a transaction ID has been received from the Make Payment API.
                                            This API may be called multiple times during the transaction lifecycle to retrieve the latest transaction status.
                                        </p>
                                    </div>
                                        <section class="docs-section row" id="item-2-3">
                                            <h2 class="section-heading">Api Params</h2>
                                            <div class="col-lg-6 col-12">
                                                <div class="attributes">
                                                <div class="attributes-head">
                                                    <h4>Request Attributes</h4>
                                                </div>

                                                <div class="attributes-contents">

                                                    <div class="attributes-contents-head">
                                                        <span class="font-weight-bold">transaction_id</span>
                                                    </div>

                                                    <p>
                                                        Type :
                                                        <span class="highlight"> String</span><br/>
                                                        Transaction Identifier returned by the Make Payment API.
                                                    </p>

                                                </div>
                                                </div>
                                            </div>
                                        </section>


                                    </div>
                                    <div class="col-lg-6 col-12 mr-4">
                                        <div class="copybox mb-3">
                                            <div class="copybox-top">
                                                <p class="copybox-para">Api Endpoint</p>
                                            </div>
                                            <div class="copybox-bottom">
                                                <pre>
                                                    <code class="copybox-code">
                                                        Method : POST <br />
                                                        &nbsp;Endpoint: /v2/merchant/get-transaction-detail
                                                    </code>
                                                </pre>
                                            </div>
                                        </div>
                                        <div class="copybox mb-3">
                                            <div class="copybox-top">
                                                <p class="copybox-para">PRE-REQUEST API KEY</p>
                                                <svg style={{cursor: "pointer"}}
                                                onClick={(e) => {
                                                    copyClipboard(e, request_data);
                                                 }}
                                                    width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9 18C8.45 18 7.97933 17.8043 7.588 17.413C7.196 17.021 7 16.55 7 16V4C7 3.45 7.196 2.979 7.588 2.587C7.97933 2.19567 8.45 2 9 2H18C18.55 2 19.021 2.19567 19.413 2.587C19.8043 2.979 20 3.45 20 4V16C20 16.55 19.8043 17.021 19.413 17.413C19.021 17.8043 18.55 18 18 18H9ZM5 22C4.45 22 3.979 21.8043 3.587 21.413C3.19567 21.021 3 20.55 3 20V7C3 6.71667 3.096 6.479 3.288 6.287C3.47933 6.09567 3.71667 6 4 6C4.28333 6 4.521 6.09567 4.713 6.287C4.90433 6.479 5 6.71667 5 7V20H15C15.2833 20 15.521 20.096 15.713 20.288C15.9043 20.4793 16 20.7167 16 21C16 21.2833 15.9043 21.5207 15.713 21.712C15.521 21.904 15.2833 22 15 22H5Z"
                                                        fill="#7281B8" />
                                                </svg>
                                                {/* <span class="highlight copied-msg">text copied</span> */}
                                            </div>
                                            <div class="copybox-bottom">
                                                <pre>
                                                    <code class="copybox-code">
                                                        {request_data}

                                                    </code>
                                                </pre>
                                            </div>
                                        </div>
                                        <div class="copybox copybox-response mb-3">
                                            <div class="copybox-top">
                                                <p class="copybox-para">RESPONSE</p>
                                                <svg 
                                                style={{cursor: "pointer"}}
                                                onClick={(e) => {
                                                    copyClipboard(e, response_data);
                                                 }} 
                                                 width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9 18C8.45 18 7.97933 17.8043 7.588 17.413C7.196 17.021 7 16.55 7 16V4C7 3.45 7.196 2.979 7.588 2.587C7.97933 2.19567 8.45 2 9 2H18C18.55 2 19.021 2.19567 19.413 2.587C19.8043 2.979 20 3.45 20 4V16C20 16.55 19.8043 17.021 19.413 17.413C19.021 17.8043 18.55 18 18 18H9ZM5 22C4.45 22 3.979 21.8043 3.587 21.413C3.19567 21.021 3 20.55 3 20V7C3 6.71667 3.096 6.479 3.288 6.287C3.47933 6.09567 3.71667 6 4 6C4.28333 6 4.521 6.09567 4.713 6.287C4.90433 6.479 5 6.71667 5 7V20H15C15.2833 20 15.521 20.096 15.713 20.288C15.9043 20.4793 16 20.7167 16 21C16 21.2833 15.9043 21.5207 15.713 21.712C15.521 21.904 15.2833 22 15 22H5Z"
                                                        fill="#7281B8"
                                                    />
                                                </svg>
                                                {/* <span class="highlight copied-msg">text copied</span> */}
                                            </div>
                                            <div class="copybox-bottom">
                                                <pre>
                                                    <code id="copy-txt" class="copybox-code ">
                                                        {response_data}
                                                    </code>
                                                </pre>
                                            </div>
                                        </div>
                                    </div>
                                </section>


                            </header>

                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                            <h2 class="section-heading">
                            Response Parameters — Transaction Details
                            </h2>

                            <table class="table table-bordered table-white">

                            <thead>
                            <tr>
                            <th>Key</th>
                            <th>Type</th>
                            <th>Description</th>
                            </tr>
                            </thead>

                            <tbody>

                            <tr>
                            <td>id</td>
                            <td>String</td>
                            <td>Transaction Identifier</td>
                            </tr>

                            <tr>
                            <td>created_at</td>
                            <td>String</td>
                            <td>Transaction Creation Date</td>
                            </tr>

                            <tr>
                            <td>amount</td>
                            <td>String</td>
                            <td>Transaction Amount</td>
                            </tr>

                            <tr>
                            <td>status</td>
                            <td>String</td>
                            <td>Transaction Status</td>
                            </tr>

                            </tbody>

                            </table>

                            </section>
                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                            <h2 class="section-heading">
                            Response Parameters — Sender Details
                            </h2>

                            <table class="table table-bordered table-white">

                            <thead>
                            <tr>
                            <th>Key</th>
                            <th>Type</th>
                            <th>Description</th>
                            </tr>
                            </thead>

                            <tbody>

                            <tr>
                            <td>first_name</td>
                            <td>String</td>
                            <td>Sender First Name</td>
                            </tr>

                            <tr>
                            <td>last_name</td>
                            <td>String</td>
                            <td>Sender Last Name</td>
                            </tr>

                            <tr>
                            <td>mobile_no</td>
                            <td>String</td>
                            <td>Sender Mobile Number</td>
                            </tr>

                            <tr>
                            <td>email</td>
                            <td>String</td>
                            <td>Sender Email Address</td>
                            </tr>

                            </tbody>

                            </table>

                            </section>
                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                            <h2 class="section-heading">
                            Response Parameters — Receiver Details
                            </h2>

                            <table class="table table-bordered table-white">

                            <thead>
                            <tr>
                            <th>Key</th>
                            <th>Type</th>
                            <th>Description</th>
                            </tr>
                            </thead>

                            <tbody>

                            <tr>
                            <td>first_name</td>
                            <td>String</td>
                            <td>Receiver First Name</td>
                            </tr>

                            <tr>
                            <td>last_name</td>
                            <td>String</td>
                            <td>Receiver Last Name</td>
                            </tr>

                            <tr>
                            <td>nationality</td>
                            <td>String</td>
                            <td>Receiver Nationality</td>
                            </tr>

                            <tr>
                            <td>currency</td>
                            <td>String</td>
                            <td>Destination Currency</td>
                            </tr>

                            <tr>
                            <td>country</td>
                            <td>String</td>
                            <td>Destination Country</td>
                            </tr>

                            <tr>
                            <td>city</td>
                            <td>String</td>
                            <td>Receiver City</td>
                            </tr>

                            <tr>
                            <td>state</td>
                            <td>String</td>
                            <td>Receiver State</td>
                            </tr>

                            <tr>
                            <td>address</td>
                            <td>String</td>
                            <td>Receiver Address</td>
                            </tr>

                            <tr>
                            <td>zip_code</td>
                            <td>String</td>
                            <td>Receiver Postal Code</td>
                            </tr>

                            </tbody>

                            </table>

                            </section>
                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                            <h2 class="section-heading">
                            Business Rules
                            </h2>

                            <table class="table table-bordered table-white">

                            <thead>
                            <tr>
                            <th>Rule</th>
                            <th>Description</th>
                            </tr>
                            </thead>

                            <tbody>

                            <tr>
                            <td>Transaction Tracking</td>
                            <td>Use this API to retrieve the latest transaction status.</td>
                            </tr>

                            <tr>
                            <td>Reconciliation</td>
                            <td>Use this API for reconciliation and reporting.</td>
                            </tr>

                            <tr>
                            <td>Transaction Reference</td>
                            <td><code>transaction_id</code> must come from the Make Payment API.</td>
                            </tr>

                            </tbody>

                            </table>

                            </section>
                        </article>

                        <article class="docs-article">
                            <section class="docs-section">

                                <h2 class="section-heading">
                                    Error Response
                                </h2>

                                <div class="copybox copybox-response">

                                    <div class="copybox-top">

                                        <p class="copybox-para">
                                            ERROR RESPONSE
                                        </p>

                                        <svg
                                            style={{ cursor: "pointer" }}
                                            onClick={(e) => {
                                                copyClipboard(e, error_response);
                                            }}
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M9 18C8.45 18 7.97933 17.8043 7.588 17.413C7.196 17.021 7 16.55 7 16V4C7 3.45 7.196 2.979 7.588 2.587C7.97933 2.19567 8.45 2 9 2H18C18.55 2 19.021 2.19567 19.413 2.587C19.8043 2.979 20 3.45 20 4V16C20 16.55 19.8043 17.021 19.413 17.413C19.021 17.8043 18.55 18 18 18H9ZM5 22C4.45 22 3.979 21.8043 3.587 21.413C3.19567 21.021 3 20.55 3 20V7C3 6.71667 3.096 6.479 3.288 6.287C3.47933 6.09567 3.71667 6 4 6C4.28333 6 4.521 6.09567 4.713 6.287C4.90433 6.479 5 6.71667 5 7V20H15C15.2833 20 15.521 20.096 15.713 20.288C15.9043 20.4793 16 20.7167 16 21C16 21.2833 15.9043 21.5207 15.713 21.712C15.521 21.904 15.2833 22 15 22H5Z"
                                                fill="#7281B8"
                                            />
                                        </svg>

                                    </div>

                                    <div class="copybox-bottom">
                                        <pre>
                                            <code class="copybox-code">
                                                {error_response}
                                            </code>
                                        </pre>
                                    </div>

                                </div>

                            </section>
                        </article>
                        
                        <article class="docs-article">
                            <section class="docs-section">

                            <h2 class="section-heading">
                            Comments
                            </h2>

                            <ul>

                            <li>
                            Store the <code>transaction_id</code> immediately after a successful payment creation.
                            </li>

                            <li>
                            Treat this API as the source of truth for transaction status.
                            </li>

                            <li>
                            Transaction status values may change during processing.
                            </li>

                            </ul>

                            </section>
                        </article>

                        <article class="docs-article" id="section-3">
                            <section class="docs-section row" id="item-3-1">
                                <div class="col-12">
                                    <nav aria-label="Page navigation example">
                                        <ul class="pagination justify-content-between">
                                        <li class="page-item">
                                            <Link
                                                class="page-link"
                                                to="/merchant-make-payment"
                                                tabIndex="-1"
                                                aria-disabled="true"
                                            >
                                                <i class="bi bi-arrow-left"></i>&nbsp;
                                                Make Payment
                                            </Link>
                                        </li>

                                        <li class="page-item">
                                            <Link
                                                class="page-link"
                                                 to="/merchant-security"
                                            >
                                                Security Recommendations&nbsp;
                                                <i class="bi bi-arrow-right"></i>
                                            </Link>
                                        </li>
                                        </ul>
                                    </nav>
                                </div>

                            </section>

                        </article>

                    </div>
                </div>
                <ToastContainer closeOnClick autoClose={2000}></ToastContainer>
            </div >
        )
    }

}